import { render } from "./CertificateViewer.vue?vue&type=template&id=2bbb742c&scoped=true"
import script from "./CertificateViewer.vue?vue&type=script&lang=js"
export * from "./CertificateViewer.vue?vue&type=script&lang=js"

import "./CertificateViewer.vue?vue&type=style&index=0&id=2bbb742c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbb742c"]])

export default __exports__